import React from 'react'
import LinkMaterial, { LinkProps as LinkMaterialProps } from '@mui/material/Link'
import ButtonBase from 'components/Button/ButtonBase'
import { color as colorTheme } from 'artmineTheme'
import styles from './Link.module.scss'
import clsx from 'clsx'

type ColorType = 'primary' | 'secondary' | LinkMaterialProps['color']

export type LinkProps = Omit<LinkMaterialProps, 'color' | 'href'> & {
  color?: ColorType
  href?: string
  to?: string
}

const linkRouterColorMap = {
  primary: styles.ColorPrimary,
  secondary: styles.ColorSecondary
}

const linkRouterFontWeightMap: any = {
  light: styles.FontLight,
  medium: styles.FontMedium,
  semibold: styles.FontSemibold,
  bold: styles.FontBold,
  extraBold: styles.FontExtraBold
}

function setColor(color?: ColorType) {
  let colorAdjusted = color

  if (color === 'primary') {
    colorAdjusted = colorTheme.primary.main
  } else if (color === 'secondary') {
    colorAdjusted = colorTheme.secondary.main
  }

  return colorAdjusted
}

const LinkRouter: React.FC<LinkProps> = props => {
  const {
    children,
    // classes,
    className,
    color = 'primary',
    fontWeight,
    underline = 'hover',
    style,
    to
  } = props

  const colorClassName =
    color === 'primary' || color === 'secondary'
      ? linkRouterColorMap[color as 'primary' | 'secondary']
      : undefined
  const styleAdjusted =
    (color && !colorClassName) || style
      ? {
          color: color as string,
          ...style
        }
      : undefined

  return (
    <ButtonBase
      className={clsx(
        styles.LinkRouter,
        colorClassName,
        fontWeight && linkRouterFontWeightMap[fontWeight as any],
        underline === 'hover' && styles.LinkRouterHoverUnderline,
        underline === 'always' && styles.LinkRouterUnderline,
        className
      )}
      to={to}
      style={styleAdjusted}
    >
      {children}
    </ButtonBase>
  )
}

const Link: React.FC<LinkProps> = props => {
  const { children, classes, className, color, fontWeight, underline, ...restProps } = props

  const colorAdjusted = setColor(color)

  return (
    <LinkMaterial
      {...restProps}
      classes={classes}
      className={className}
      color={colorAdjusted}
      fontWeight={fontWeight}
      underline={underline || 'hover'}
    >
      {children}
    </LinkMaterial>
  )
}

const LinkContainer: React.FC<LinkProps> = props => {
  const { to, href, ...restProps } = props
  if (to) return <LinkRouter {...restProps} to={to} />

  return <Link {...restProps} href={href} />
}

export default LinkContainer
